import React from 'react';

export const PivotTableTooltipContent: React.FC<{
  formula: React.ReactNode;
  calculation: React.ReactNode;
}> = ({ formula, calculation }) => (
  <div className="tw-p-2 tw-text-left tw-text-sm">
    <div>
      <span className="tw-text-xs tw-font-normal tw-text-black/50">
        Formula:
      </span>
      <br />
      {formula}
    </div>
    <div className="tw-pt-2">
      <span className="tw-text-xs tw-font-normal tw-text-black/50">
        Calculation:
      </span>
      <br />
      <span className="tw-font-normal">{calculation}</span>
    </div>
  </div>
);
